<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="card">
        <div class="card-header">
          {{ t.giro }}
        </div>
        <DateFilter :startDate="startDate" :endDate="endDate" v-on:data-change="updateDate"></DateFilter>
        <div class="card-block p-0">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
              <tr>
                <th></th>
                <th>Casino</th>
                <th>Sport</th>
                <th>{{ t.total }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="loading">
                <td colspan="4" align="center">
                  <Loading></Loading>
                </td>
              </tr>
              <template v-if="!loading">
                <tr v-if="data.length < 1">
                  <td colspan="4" align="center">Kayıt yok</td>
                </tr>
                <tr>
                  <td><strong>{{ t.total }}</strong> </td>
                  <td>
                    <router-link :to="{query: {casino_report: session.uid}}">
                      {{ totalCasinoProfit | toMoney(session.currency)}}
                    </router-link>
                  </td>
                  <td>{{ totalBetProfit | toMoney(session.currency) }}</td>
                  <td>{{ total | toMoney(session.currency) }}</td>
                </tr>
                <template v-for="d in data">
                  <AdminGiroRow :d="d" :start="startDate" :end="endDate"/>
                </template>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <sweet-modal ref="cp" width="100%" v-on:close="closeCasinoProviderReport()">
        <ProviderCasino :id="$route.query.casino_report" :start="startDate" :end="endDate"/>
    </sweet-modal>
  </div>
</template>

<script>
import DateFilter from "../DateFilter";
import Loading from "../Loading";
import AdminGiroRow from "../row/AdminGiroRow";
import ProviderCasino from "../views/ProviderCasino";
export default {
  name: "AdminGiro",
  components: {Loading, DateFilter, AdminGiroRow, ProviderCasino},
  data() {
    return {
      session: window.session,
      startDate: (moment().locale('en').format('dddd') !== 'Monday') ? moment().startOf('week').add(1, 'days').format("DD MMMM YYYY ddd") 
      : moment().startOf('week').subtract(6,'days').format("DD MMMM YYYY ddd"),
      endDate: moment().format("DD MMMM YYYY ddd"),
      data: [],
      loading: false,
      t: this.$root.t,
      totalBetProfit: 0,
      totalCasinoProfit: 0,
      total: 0
    }
  },
  watch: {
    'startDate' () {
        this.updateDate()
    },
    'endDate' () {
        this.updateDate()
    },
    '$route.query.casino_report' () {

      if(this.$route.query.casino_report > 0)
        this.$refs.cp.open()
    },
    '$route.query.referrer' () {

      setTimeout(() => {
        this.fetchCustomers();
      },1000);
    }
  },
  mounted() {
    this.fetchCustomers();

  },
  methods: {
    closeCasinoProviderReport () {

        this.$router.back()
    },
    updateDate (e) {
      //console.log(e)
      this.fetchCustomers()

    },
    fetchCustomers() {

      this.totalBetProfit = 0;
      this.totalCasinoProfit = 0;
      this.total = 0;
      this.loading = true;
      this.$http.get(api + 'api/v1/users', {
        params: {
          page: this.$route.query.page,
          per_page: 100,
          group: [3],
          direction: 'desc',
          referrer: this.$route.query.referrer
        }
      })
      .then(response => {
        this.data = response.body.result.users;
        this.loading = false;
      }, response => {
        this.loading = false;
        this.data = [];
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/AdminGiro.vue